import moment from "moment";
import { always, cond, equals, pathOr, T } from "ramda";
import React from "react";
import {
  getDataValueBasedOnStateValue,
  momentToStr,
} from "../../../job-posting/helpers";
import { currencyFormatter } from "../../functions/formatters";

const formatCurrency = currencyFormatter();

export const jobStatData = ({ data = {}, formState = {} }) => [
  { data: moment().format("MM/DD/YYYY"), title: "Posted" },
  {
    data: momentToStr(
      moment.utc(pathOr(null, ["resume_deadline"], formState)),
      "L",
    ),
    title: "Deadline",
  },
  { data: formState.position_type, title: "Position" },
  {
    data: `${formState.base_compensation_min ? formatCurrency(formState.base_compensation_min) : "N/A"}`,
    title: getPayScheduleType(formState.pay_schedule),
  },
];

export const getPayScheduleType = (paySchedule) => {
  if (paySchedule) {
    return cond([
      [equals("Hourly"), always("Per Hour")],
      [equals("Weekly"), always("Per Week")],
      [equals("Salary"), always("Per Year")],
      [T, always(`N/A`)],
    ])(paySchedule);
  } else return "N/A";
};

export const createMarkup = (formState, editor) => {
  if (!formState || !formState[editor] || formState[editor].length === 0) {
    return null;
  }

  const content = formState[editor];

  // Check if content is HTML (contains HTML tags)
  const isHtml = /<[^>]*>/g.test(content);

  if (isHtml) {
    // Strip paragraph tags but preserve line breaks and other formatting
    const processedContent = content
      .replace(/<p[^>]*>/g, "") // Remove opening p tags
      .replace(/<\/p>/g, "<br/>") // Replace closing p tags with line breaks
      .replace(/<br\/>\s*$/, ""); // Remove trailing line break

    return <div dangerouslySetInnerHTML={{ __html: processedContent }} />;
  } else {
    // Content is plain text, render as text
    return <div>{content}</div>;
  }
};

export const jobInformationData = ({ data, formState }) =>
  [
    {
      title: "Job Category:",
      children: getDataValueBasedOnStateValue(
        data.job_category,
        formState.job_category,
      ),
    },
    {
      title: "Position Type:",
      children: getDataValueBasedOnStateValue(
        data.position_type,
        formState.position_type,
      ),
    },
    {
      title: "Base Compensation:",
      children: `${formatCurrency(formState.base_compensation_min)} ${getPayScheduleType(getDataValueBasedOnStateValue(data.pay_schedule, formState.pay_schedule))}`,
    },
    {
      title: "Max Compensation:",
      children:
        formState.base_compensation_max &&
        `${formatCurrency(formState.base_compensation_max)} ${getPayScheduleType(getDataValueBasedOnStateValue(data.pay_schedule, formState.pay_schedule))}`,
    },
    {
      title: "Additional Income:",
      children: createMarkup(formState, "additional_income"),
    },
    {
      title: "Total Compensation:",
      children:
        formState.total_anticipated_compensation &&
        `${formatCurrency(formState.total_anticipated_compensation)} ${getPayScheduleType(getDataValueBasedOnStateValue(data.pay_schedule, formState.pay_schedule))}`,
    },
    {
      title: "Education:",
      children: getDataValueBasedOnStateValue(
        data.education,
        formState.education,
      ),
    },
    {
      title: "Additional PGA Education:",
      children: getDataValueBasedOnStateValue(
        data.additional_pga_education,
        formState.additional_pga_education,
      ),
    },
  ].filter((item) => item.children);

export const jobAdditionalData = ({ formState }) =>
  [
    { title: "Overview", children: createMarkup(formState, "overview") },
    {
      title: "Experience Required",
      children: createMarkup(formState, "experience_required"),
    },
    {
      title: "Essential Responsibilities",
      children: createMarkup(formState, "essential_responsibilities"),
    },
    { title: "Benefits", children: createMarkup(formState, "benefits") },
  ].filter((item) => item.children);

const PGA_PRO_APPLICANT_GROUP = "11382848";
export const isPgaProApplicantGroup = (data) =>
  data === PGA_PRO_APPLICANT_GROUP;
